import { render, staticRenderFns } from "./reset-scores.vue?vue&type=template&id=17223567&scoped=true"
import script from "./reset-scores.vue?vue&type=script&lang=js"
export * from "./reset-scores.vue?vue&type=script&lang=js"
import style0 from "./reset-scores.vue?vue&type=style&index=0&id=17223567&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17223567",
  null
  
)

export default component.exports